import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
};

const layoutSlice = createSlice({
  name: "auth",
  initialState,

  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload || false;
    },
  },
});

export const { setLoading } = layoutSlice.actions;

const { reducer: layoutReducer } = layoutSlice;
export default layoutReducer;
